var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_2525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.68 10.9425C22.9643 11.2575 23.1216 11.6667 23.1216 12.091C23.1216 12.5154 22.9643 12.9246 22.68 13.2396C20.88 15.1767 16.7828 18.9482 12 18.9482C7.21711 18.9482 3.11996 15.1767 1.31996 13.2396C1.03567 12.9246 0.878296 12.5154 0.878296 12.091C0.878296 11.6667 1.03567 11.2575 1.31996 10.9425C3.11996 9.00532 7.21711 5.23389 12 5.23389C16.7828 5.23389 20.88 9.00532 22.68 10.9425Z",
    stroke: "#4E4B66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5195C13.8935 15.5195 15.4286 13.9845 15.4286 12.0909C15.4286 10.1974 13.8935 8.66235 12 8.66235C10.1064 8.66235 8.57141 10.1974 8.57141 12.0909C8.57141 13.9845 10.1064 15.5195 12 15.5195Z",
    stroke: "#4E4B66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0910645)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye-1.36fc9aad749e552c297ffcf1d00655bf.svg";
export { ForwardRef as ReactComponent };